"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Image = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _constants = require("../../../BannerProductListing/constants");
var _types = require("../../types");
const Image = exports.Image = (0, _mui.styled)('img', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { promoBannerType, theme, size, isFocusPage } = param;
    return {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        flexShrink: 0,
        ...promoBannerType === _types.PromoBannerType.Split ? {
            maxHeight: isFocusPage ? _constants.BANNER_SPLIT_DESKTOP_HEIGHT : _constants.BANNER_SPLIT_MOBILE_HEIGHT[size]
        } : {},
        [theme.breakpoints.up('sm')]: {
            ...promoBannerType === _types.PromoBannerType.Split ? {
                maxHeight: _constants.BANNER_SPLIT_DESKTOP_HEIGHT
            } : {}
        }
    };
});
